import { BrandMark } from "@/components/shared/brand-mark";
import { Icon } from "@/components/ui/icon";
import { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";
import { roleLabels } from "@/lib/labels";
import { initials } from "@/lib/utils";
import { navigationFor, type NavigationItem } from "./navigation";

export function Sidebar() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  if (!user) return null;

  /* mismo criterio que NavLink, pero la clase activa va en el <li> (lo pide el CSS) */
  const isActive = (item: NavigationItem) =>
    item.end
      ? pathname === item.href
      : pathname === item.href || pathname.startsWith(`${item.href}/`);

  return (
    <nav
      aria-label="Navegación principal"
      className="sidebar sidebar-dark-pickled-bluewood scp-sidebar"
      data-perfect-scrollbar
    >
      <Link to="/dashboard" className="sidebar-brand ">
        <span className="avatar avatar-xl sidebar-brand-icon h-auto">
          <span className="avatar-title rounded bg-primary">
            <BrandMark />
          </span>
        </span>
        <span>SCP</span>
      </Link>

      {/* sin .sidebar-account: en los sidebars oscuros el template le pone
          fondo blanco (pastilla) y el nombre en blanco desaparecia */}
      <div className="sidebar-block d-flex align-items-center">
        <span className="avatar avatar-sm mr-12pt">
          {user.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt=""
              className="avatar-img rounded-circle"
            />
          ) : (
            <span className="avatar-title rounded-circle bg-primary">
              {initials(user.firstName, user.lastName)}
            </span>
          )}
        </span>
        <span className="flex d-flex flex-column">
          <strong
            className="sidebar-text scp-sidebar-name"
            title={`${user.firstName} ${user.lastName}`}
          >
            {user.firstName} {user.lastName}
          </strong>
          <small className="sidebar-text text-50">
            {roleLabels[user.role] ?? user.role}
          </small>
        </span>
      </div>

      {navigationFor(user.role).map((section) => (
        <Fragment key={section.heading}>
          <div className="sidebar-heading">{section.heading}</div>
          <ul className="sidebar-menu">
            {section.items.map((item) => (
              <li
                key={item.href}
                className={`sidebar-menu-item${isActive(item) ? " active" : ""}`}
              >
                <Link
                  className="sidebar-menu-button"
                  to={item.href}
                  aria-current={isActive(item) ? "page" : undefined}
                >
                  <Icon
                    name={item.icon}
                    className=" sidebar-menu-icon sidebar-menu-icon--left"
                  />
                  <span className="sidebar-menu-text">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </Fragment>
      ))}

      <div className="sidebar-heading">Sesion</div>
      <ul className="sidebar-menu">
        <li
          className={`sidebar-menu-item${pathname === "/profile" ? " active" : ""}`}
        >
          <Link
            className="sidebar-menu-button"
            to="/profile"
            aria-current={pathname === "/profile" ? "page" : undefined}
          >
            <Icon
              name="account_circle"
              className=" sidebar-menu-icon sidebar-menu-icon--left"
            />
            <span className="sidebar-menu-text">Mi perfil</span>
          </Link>
        </li>
        <li className="sidebar-menu-item">
          <a
            className="sidebar-menu-button"
            href="#logout"
            onClick={(event) => {
              event.preventDefault();
              void logout();
            }}
          >
            <Icon
              name="exit_to_app"
              className=" sidebar-menu-icon sidebar-menu-icon--left"
            />
            <span className="sidebar-menu-text">Cerrar sesion</span>
          </a>
        </li>
      </ul>
    </nav>
  );
}
